import { Route, Routes } from "react-router-dom";
import React from "react";
import MembershipLayout from "js/components/MembershipLayout";
import MembershipPlans from "js/pages/Memberships/MembershipPlans";
import MembershipGeneral from "js/pages/Memberships/MembershipGeneral";
import MembershipConfiguration from "js/pages/Memberships/MembershipConfiguration";
import MembershipCheckout from "js/pages/Memberships/MembershipCheckout";
import NotFound from "js/pages/NotFound";

const MembershipRouter = () => {
  return (
    <Routes>
      <Route element={<MembershipLayout />}>
        <Route path="general" element={<MembershipGeneral />} />
        <Route path="config" element={<MembershipConfiguration />} />
        <Route path="pricing" element={<MembershipPlans />} />
        <Route path="checkout" element={<MembershipCheckout />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default MembershipRouter;
